"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var icons_1 = require("../../icons");
var atoms_1 = require("../../atoms");
var hooks_1 = require("../../hooks");
var styles_1 = __importDefault(require("./styles"));
var themes_1 = require("../../themes");
exports.SearchBar = react_1.default.memo(function (_a) {
    var fullWidth = _a.fullWidth, _b = _a.id, id = _b === void 0 ? "search" : _b, _c = _a.label, label = _c === void 0 ? "search" : _c, _d = _a.placeholder, placeholder = _d === void 0 ? "Search" : _d, showSearchIcon = _a.showSearchIcon, _e = _a.onChange, onChange = _e === void 0 ? function () { } : _e, _f = _a.onClearSearch, onClearSearch = _f === void 0 ? function () { } : _f, rest = __rest(_a, ["fullWidth", "id", "label", "placeholder", "showSearchIcon", "onChange", "onClearSearch"]);
    var classes = (0, styles_1.default)();
    var _g = (0, react_1.useState)((rest === null || rest === void 0 ? void 0 : rest.defaultValue) || ""), inputValue = _g[0], setInputValue = _g[1];
    var debounce = (0, hooks_1.useDebounce)(onChange).debounce;
    var handleInputOnChange = function (e) {
        setInputValue(e.target.value);
        debounce(e);
    };
    var clearSearch = function () {
        onClearSearch();
        setInputValue("");
    };
    return ((0, jsx_runtime_1.jsx)(core_1.FormControl, __assign({ fullWidth: fullWidth }, { children: (0, jsx_runtime_1.jsx)(atoms_1.EnclosedTextField, __assign({ id: id, label: label, value: inputValue, placeholder: placeholder, fullWidth: fullWidth }, rest, { onChange: handleInputOnChange, InputProps: {
                endAdornment: ((0, jsx_runtime_1.jsxs)(core_1.InputAdornment, __assign({ className: classes.root, position: "end" }, { children: [(0, jsx_runtime_1.jsx)(core_1.Box, __assign({ hidden: Boolean(!(inputValue === null || inputValue === void 0 ? void 0 : inputValue.length)) }, { children: (0, jsx_runtime_1.jsx)(atoms_1.IconButton, { id: "ClearSearchBarButton", onClick: clearSearch, color: themes_1.materialColors.blue[400], "data-testid": "search-cancel-button", icon: (0, jsx_runtime_1.jsx)(atoms_1.Icon, __assign({ size: "medium" }, { children: (0, jsx_runtime_1.jsx)(icons_1.Cancel, {}) })) }) })), (0, jsx_runtime_1.jsx)(core_1.Box, __assign({ hidden: !showSearchIcon || (inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) > 0, className: classes.endIcon }, { children: (0, jsx_runtime_1.jsx)(atoms_1.Icon, __assign({ size: "medium" }, { children: (0, jsx_runtime_1.jsx)(icons_1.Search, {}) })) }))] }))),
            } })) })));
});
